module.exports = __webpack_public_path__ + "img/homepage-banners-mazda-compliant-cjdr.d5aa64c7.jpg";